// The display key a fixture is filed under.
//
// A mock fixture is nobody's feed, but the analyst can still hide columns on it, so the page has to
// file those choices under SOME key. The key used to be the displayed feed id, which for a mock was
// `null` — so the choices landed on the literal property `"null"`, shared by every mock kind and
// sitting in the same map as real feeds. Hiding Sector on the multi-input fixture hid it on the
// single-input one, and a feed genuinely called nothing would have collided with both.
//
// The prefix is what keeps these keys out of the feed namespace: `GET /feeds` ids are bare
// identifiers, so a colon cannot appear in one.
//
// Its own module, tiny, because BOTH the page and the fixture need the vocabulary and neither
// should have to import the other to get it: the page would otherwise pull 385 lines of fixture
// data into the production bundle to learn what a colon means, and the fixture would have to import
// the page. Keeping it here is what lets mockFeed.js stamp its own key — which is what lets a
// result say which feed it belongs to without the page holding a ref to remember.

const MOCK_FEED_KEY_PREFIX = 'mock:';

export const mockFeedKey = (kind) => `${MOCK_FEED_KEY_PREFIX}${kind}`;

// A mock key is a display key and nothing else. No request may be built for it and no server may be
// asked about it — there is no server on the other end of a fixture.
export const isMockFeedKey = (feedId) => typeof feedId === 'string' && feedId.startsWith(MOCK_FEED_KEY_PREFIX);
